module.exports = __webpack_public_path__ + "media/images/awards/award-photo-4-6f4ebfd6b46a9e7fb919767a4931db81.jpeg";